import {
  ERROR_TEXT,
  FOCUS_RING,
  FOCUS_RING_ERROR,
  FORM_BORDER,
  FORM_BORDER_ERROR,
  FORM_BORDER_HOVER,
  FORM_RADIUS,
  LABEL_TEXT,
} from './tokens';

interface TextareaProps {
  readonly label?: string;
  readonly error?: string;
  readonly rows?: number;
  readonly disabled?: boolean;
  readonly required?: boolean;
  readonly id?: string;
  readonly value: string;
  readonly onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  readonly placeholder?: string;
  readonly readOnly?: boolean;
  readonly maxLength?: number;
}

export function Textarea({
  label,
  error,
  rows = 3,
  disabled,
  required,
  id,
  value,
  onChange,
  placeholder,
  readOnly,
  maxLength,
}: TextareaProps) {
  const hasError = Boolean(error);

  const borderClass = hasError ? FORM_BORDER_ERROR : FORM_BORDER;
  const focusClass = hasError ? FOCUS_RING_ERROR : FOCUS_RING;
  let bgClass = 'bg-white';
  if (disabled) bgClass = 'bg-slate-50 cursor-not-allowed';
  else if (readOnly) bgClass = 'bg-slate-50';

  return (
    <div>
      {label !== undefined && (
        <label htmlFor={id} className={`block ${LABEL_TEXT} mb-1.5`}>
          {label}
          {required === true && <span className="ml-0.5 text-red-500">*</span>}
        </label>
      )}
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        rows={rows}
        disabled={disabled}
        required={required}
        readOnly={readOnly}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`w-full px-4 py-3 resize-none ${borderClass} ${FORM_BORDER_HOVER} ${focusClass} ${FORM_RADIUS} ${bgClass}`}
      />
      {hasError && <p className={ERROR_TEXT}>{error}</p>}
    </div>
  );
}
